import {
  contentSlideHeader,
  headerTextStyles,
} from '@features/lci-report/utils';
import { TITLE } from '../../shared/dark-background-slide-master';
import { Slide } from '@features/powerpoint';
import { theme } from '@features/lci-report/domain/theme';

export const baseSlide = (): Slide => ({
  slideMaster: TITLE,
  texts: [
    contentSlideHeader('LCI - Projected Visits Methodology', {
      color: theme.colors.white,
    }),
    {
      text: 'Projected using campaign Match Rate',
      options: {
        color: theme.colors.white,
        x: headerTextStyles.contentSlide.x,
        y: 1.5,
        w: 6,
        h: 0.5,
        fontSize: 14,
      },
    },
  ],
});
